import * as a from "react";
import { jsx as C } from "react/jsx-runtime";
import * as P from "react-dom";
import { S as w } from "./index-DoOsnuB6.js";
function E(t, n = []) {
  let r = [];
  function m(c, e) {
    const o = a.createContext(e), i = r.length;
    r = [...r, e];
    const d = (p) => {
      var S;
      const { scope: u, children: v, ...f } = p, x = ((S = u == null ? void 0 : u[t]) == null ? void 0 : S[i]) || o, h = a.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ C(x.Provider, { value: h, children: v });
    };
    d.displayName = c + "Provider";
    function l(p, u) {
      var x;
      const v = ((x = u == null ? void 0 : u[t]) == null ? void 0 : x[i]) || o, f = a.useContext(v);
      if (f) return f;
      if (e !== void 0) return e;
      throw new Error(`\`${p}\` must be used within \`${c}\``);
    }
    return [d, l];
  }
  const s = () => {
    const c = r.map((e) => a.createContext(e));
    return function(o) {
      const i = (o == null ? void 0 : o[t]) || c;
      return a.useMemo(
        () => ({ [`__scope${t}`]: { ...o, [t]: i } }),
        [o, i]
      );
    };
  };
  return s.scopeName = t, [m, b(s, ...n)];
}
function b(...t) {
  const n = t[0];
  if (t.length === 1) return n;
  const r = () => {
    const m = t.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(c) {
      const e = m.reduce((o, { useScope: i, scopeName: d }) => {
        const p = i(c)[`__scope${d}`];
        return { ...o, ...p };
      }, {});
      return a.useMemo(() => ({ [`__scope${n.scopeName}`]: e }), [e]);
    };
  };
  return r.scopeName = n.scopeName, r;
}
var _ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], M = _.reduce((t, n) => {
  const r = a.forwardRef((m, s) => {
    const { asChild: c, ...e } = m, o = c ? w : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ C(o, { ...e, ref: s });
  });
  return r.displayName = `Primitive.${n}`, { ...t, [n]: r };
}, {});
function N(t, n) {
  t && P.flushSync(() => t.dispatchEvent(n));
}
export {
  M as P,
  E as c,
  N as d
};
